<cerrix-loader [cerrixTab]="tab"></cerrix-loader>
@if (model) {
    <div class="detail-page-action-bar flex-action-bar">
        <div>
            <!-- save() reads the form of detailMain, which exists only after its data loads. -->
            <button
                data-uiid="button-savetaskseries"
                class="btn btn-cerrix"
                [disabled]="!detailMain.formGroup"
                (click)="save()"
            >
                <i class="fas fa-save"></i>
                <span class="d-none d-lg-inline">{{ 'save' | t }}</span>
            </button>
        </div>
    </div>

    <div
        class="task-series-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
    >
        <div
            class="task-series-screens"
            [attr.name]="'taskSeries' | t"
            menuicon="fa-fw fa-tasks far"
            menusystemsubmenu
        >
            <div
                menuItemId="menuDetails"
                [attr.name]="'details' | t"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <task-series-detail-main
                    [model]="model"
                    [cerrixTab]="tab"
                    [permissions]="permissions"
                    #detailMain
                >
                </task-series-detail-main>
            </div>
            @if (id) {
                @if (isInitialized && permissions) {
                    <div
                        class="task-series-screens"
                        [attr.menuItemId]="'menuLinks'"
                        [attr.name]="'links' | t"
                        menuicon="fas fa-link"
                        menusystemsubmenu
                    >
                        <div
                            menuItemId="menuItemTasks"
                            [attr.name]="'tasks' | t"
                            menuicon="fa-fw fa-tasks far"
                            menusystemitem
                        >
                            <generic-pagination-list-manager
                                [config]="this.tasksConfig"
                            ></generic-pagination-list-manager>
                        </div>
                        @if (model.linkedTypes.includes(taskType.ControlExecution)) {
                            <div
                                menuItemId="menuItemControls"
                                [attr.name]="'controls' | t"
                                menuicon="fas fa-shield-alt"
                                menusystemitem
                            >
                                <!-- control linking disabled for now -->
                                <task-series-controls
                                    [model]="model"
                                    [disabled]="true || !permissions.canEdit"
                                    #taskseriescontrols
                                ></task-series-controls>
                            </div>
                        }
                        <div
                            menuItemId="menuItemDocuments"
                            [attr.name]="'documents' | t"
                            menuicon="far fa-file"
                            menusystemitem
                        >
                            @if (documents) {
                                <div>
                                    <!-- AllowEdit is set to false to prevent problems with replacing a changed file in the related task and control execution documents.
                                    The way it is implemented causes the task and control execution document to be deleted because these have an DocumentId
                                    that does not match the document id of the task series -->
                                    <document-manager-old
                                        [(Documents)]="model.Documents"
                                        (DocumentsChange)="checkDocumentsDirty()"
                                        [permissions]="permissions.documentPermissions"
                                        [AllowEdit]="false"
                                        [DocumentTypeTargets]="targetModule"
                                    >
                                    </document-manager-old>
                                </div>
                            } @else {
                                <div>
                                    <div class="fancy-loader"></div>
                                </div>
                            }
                        </div>
                        <div
                            menuItemId="menuItemHyperlinks"
                            [attr.name]="'hyperlinks' | t"
                            menuicon="fas fa-external-link-alt"
                            menusystemitem
                        >
                            @if (model.Hyperlinks) {
                                <div>
                                    <hyperlink-manager
                                        [Hyperlinks]="model.Hyperlinks"
                                        (HyperlinksChanged)="checkHyperlinksDirty()"
                                        [TargetModule]="targetModule"
                                    ></hyperlink-manager>
                                </div>
                            } @else {
                                <div>
                                    <div class="fancy-loader"></div>
                                </div>
                            }
                        </div>
                    </div>
                }

                <div menuItemId="Options" [attr.name]="'options' | t" menuicon="fas fa-check-double" menusystemitem>
                    <detail-options
                        moduleName="task serie"
                        [objectName]="model ? model.name : 'task serie'"
                        [allowDelete]="permissions.canDelete"
                        customText='Are you sure you want to delete the task series? Tasks marked "Done" will be removed as well.'
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
